import {
  Box,
  Checkbox,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Typography
} from '@material-ui/core'
import React, { useState } from 'react'

import pasargadGatewayLogo from '../../assets/images/pasargadGatewayLogo.png'
import samanGatewayLogo from '../../assets/images/samanGatewayLogo.png'
import SectionTitle from '../../components/SectionTitle'
import { getTranslate } from '../../localization'
import { Proforma } from '../../types/walletProforma'
import useStyles from './styles/PaymentMethod.styles'
import { UploadBox } from './uploadBox'

interface PaymentMethodProps {
  proforma: Proforma
  disabled: boolean
  onlinePaymentSelected: boolean
  setonlinePaymentSelected: React.Dispatch<React.SetStateAction<boolean>>
  attachments: string[]
  setattachments: React.Dispatch<React.SetStateAction<string[]>>
}

const PaymentMethod: React.FC<PaymentMethodProps> = ({
  disabled,
  onlinePaymentSelected,
  setonlinePaymentSelected,
  proforma,
  attachments,
  setattachments
}) => {
  const classes = useStyles()
  const [selectedBank, setSelectedBank] = useState('saman')
  const [agreedTerms, setAgreedTerms] = useState(false)

  const banks = [
    {
      id: 'saman',
      name: 'Saman Bank',
      icon: samanGatewayLogo,
      disabled: false
    },
    {
      id: 'pasargad',
      name: 'Pasargad Bank',
      icon: pasargadGatewayLogo,
      disabled: true
    }
  ]

  return (
    <>
      <SectionTitle title="Payment Method" marginBottom />
      <Box
        className={`${classes.container} ${
          disabled ? classes.disabledContainer : ''
        }`}>
        <Box className={classes.methodType}>
          <RadioGroup
            className={classes.switch}
            value={onlinePaymentSelected ? 'Online' : 'Offline'}
            onChange={(event) =>
              setonlinePaymentSelected(
                event.target.value === 'Offline' ? false : true
              )
            }>
            <FormControlLabel
              value="Online"
              control={<Radio color="primary" />}
              label={getTranslate('Online')}
            />
            <FormControlLabel
              value="Offline"
              control={<Radio color="primary" />}
              label={getTranslate('Offline')}
            />
          </RadioGroup>
        </Box>

        {!onlinePaymentSelected ? (
          <UploadBox
            disabled={disabled}
            entityCode={proforma.proformaNumber}
            entityID={proforma.proformaID.toString()}
            {...{ attachments, setattachments }}
          />
        ) : (
          <>
            <Box className={classes.banksContainer}>
              {banks.map((bank) => (
                <Paper
                  key={bank.id}
                  elevation={0}
                  className={`${classes.bankOption} ${
                    selectedBank === bank.id ? classes.selectedBank : ''
                  } ${bank.disabled ? classes.disabledBank : ''}`}
                  onClick={() => !bank.disabled && setSelectedBank(bank.id)}>
                  <img
                    src={bank.icon}
                    alt={bank.name}
                    className={classes.bankIcon}
                  />
                  <Typography variant="body2">{bank.name}</Typography>
                </Paper>
              ))}
            </Box>
          </>
        )}
        <Box className={classes.termsContainer}>
          <Checkbox
            checked={agreedTerms}
            onChange={(e) => setAgreedTerms(e.target.checked)}
            color="primary"
          />
          <Typography variant="body2">
            {getTranslate('I agree Terms & conditions')}
          </Typography>
        </Box>
      </Box>
    </>
  )
}

export default PaymentMethod
